import { render, staticRenderFns } from "./emailPreview.vue?vue&type=template&id=c2f40ee0"
import script from "./emailPreview.vue?vue&type=script&lang=js"
export * from "./emailPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports